import { render } from "./PotsChart.vue?vue&type=template&id=6aac875e&ts=true"
import script from "./PotsChart.vue?vue&type=script&lang=ts"
export * from "./PotsChart.vue?vue&type=script&lang=ts"

import "./PotsChart.vue?vue&type=style&index=0&id=6aac875e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__